export function pageSlugFromName(name) {
  return String(name || '')
    .split('/')
    .filter((segment) => {
      const normalizedSegment = segment.trim()
      return (
        normalizedSegment !== '' &&
        normalizedSegment !== '.' &&
        normalizedSegment !== '..'
      )
    })
    .map((segment) =>
      segment
        .replace(/\W{1,}/g, '-')
        .toLowerCase()
        .trim(),
    )
    .filter(Boolean)
    .join('/')
}
